import * as React from 'react';

/**
 * We lazy load the insights components as they include large datasets.
 */
export const SiteInsightsLinkUsageButton = React.lazy(async () => {
    const { SiteInsightsLinkUsageButton } = await import('./index.lazy');
    return { default: SiteInsightsLinkUsageButton };
});

export const SiteInsightsTrafficReport = React.lazy(async () => {
    const { SiteInsightsTrafficReport } = await import('./index.lazy');
    return { default: SiteInsightsTrafficReport };
});

export const SiteInsightsOpenAPIReport = React.lazy(async () => {
    const { SiteInsightsOpenAPIReport } = await import('./index.lazy');
    return { default: SiteInsightsOpenAPIReport };
});

export const SiteInsightsLinksReport = React.lazy(async () => {
    const { SiteInsightsLinksReport } = await import('./index.lazy');
    return { default: SiteInsightsLinksReport };
});

export const SiteInsightsSearchReport = React.lazy(async () => {
    const { SiteInsightsSearchReport } = await import('./index.lazy');
    return { default: SiteInsightsSearchReport };
});

export const SiteInsightsAskReport = React.lazy(async () => {
    const { SiteInsightsAskReport } = await import('./index.lazy');
    return { default: SiteInsightsAskReport };
});

export const SiteInsightsPagesReport = React.lazy(async () => {
    const { SiteInsightsPagesReport } = await import('./index.lazy');
    return { default: SiteInsightsPagesReport };
});

export const SiteInsightsAdsReport = React.lazy(async () => {
    const { SiteInsightsAdsReport } = await import('./index.lazy');
    return { default: SiteInsightsAdsReport };
});

export const SiteInsightsOverview = React.lazy(async () => {
    const { SiteInsightsOverview } = await import('./index.lazy');
    return { default: SiteInsightsOverview };
});

export const SiteInsightsBrokenURLsReport = React.lazy(async () => {
    const { SiteInsightsBrokenURLsReport } = await import('./index.lazy');
    return { default: SiteInsightsBrokenURLsReport };
});

export * from './state';
